/**
 * @generated SignedSource<<b6bd3258823ee2f195c2bd8eaf433395>>
 * @relayHash 8a4bdd1ae8313ced38b6ca109ff65946
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8a4bdd1ae8313ced38b6ca109ff65946

import type { ConcreteRequest } from 'relay-runtime';
export type IssuePlanBodyQuery$variables = {
  id: string;
};
export type IssuePlanBodyQuery$data = {
  readonly node: {
    readonly planBodyHTML?: string | null | undefined;
  } | null | undefined;
};
export type IssuePlanBodyQuery = {
  response: IssuePlanBodyQuery$data;
  variables: IssuePlanBodyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planBodyHTML",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IssuePlanBodyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssuePlanBodyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "8a4bdd1ae8313ced38b6ca109ff65946",
    "metadata": {},
    "name": "IssuePlanBodyQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4f73e512c801584c3812d888fea24ed7";

export default node;
